import {
  AgencyRow,
  AgencyDetails,
  AgencyName,
  AgencySubtitle,
} from './TransferToAgencyModal.styles';
import type { Agency } from './types';

interface AgencyListItemProps {
  agency: Agency;
  isSelected: boolean;
  onSelect: (id: string) => void;
}

function AgencyListItem({ agency, isSelected, onSelect }: AgencyListItemProps) {
  return (
    <AgencyRow
      $isSelected={isSelected}
      onClick={() => onSelect(agency.identifier)}
      data-name={`agency-item-${agency.identifier}`}
    >
      <input
        type="radio"
        name="agency-selection"
        checked={isSelected}
        onChange={() => onSelect(agency.identifier)}
      />
      <AgencyDetails>
        <AgencyName>{agency.name}</AgencyName>
        {agency.state != null && agency.distanceMi != null && (
          <AgencySubtitle>
            {agency.state} &middot; {agency.distanceMi} mi
          </AgencySubtitle>
        )}
      </AgencyDetails>
    </AgencyRow>
  );
}

export default AgencyListItem;
